























































import { GENERATE_S3_URL } from "@/queries/user/mutation.graphql";
import Vue from "vue";
export default Vue.extend({
  props: {
    fileLabel: {
      type: String
    },
    label: {
      type: String,
      default: "Upload File"
    },
    id: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      required: true
    },
    url: {
      type: String
    }
  },
  data() {
    return {
      mode: null,
      isLoading: false
    };
  },
  computed: {
    fileAvailable() {
      return this.fileLabel && this.fileLabel.length > 0 ? true : false;
    }
  },
  methods: {
    onLabelClick(e) {
      if (this.fileAvailable) {
        e.preventDefault();
      }
    },
    async upload(e: Event) {
      const input: HTMLInputElement = e.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        this.isLoading = true;
        const uploadedFile = input.files[0];
        const fileName = uploadedFile.name.replace(/-/g, "_");
        const { data, errors } = await this.$apollo.mutate({
          mutation: GENERATE_S3_URL,
          variables: {
            fileName
          }
        });

        if (errors) {
          return;
        }

        if (data && data.generateS3UploadUrl) {
          const file = new File([uploadedFile], uploadedFile.name, {
            type: uploadedFile.type
          });
          const url = data.generateS3UploadUrl.uploadUrl;

          await fetch(url, {
            method: "PUT",
            body: file,
            headers: { "Content-Type": file.type }
          });

          const fileUrl = url.split("?")[0];
          this.$emit("upload", fileUrl);
          this.isLoading = false;
          this.mode = null;
        }
      }
    }
  }
});
